import { useLayoutEffect } from "react";

import { useMe } from "@/hooks/queries/user.queries";

const DATA_ATTR = "data-elitphone-user-email";

function setEmailInDom(email: string | null) {
    const body = document.body;
    if (email) {
        body.setAttribute(DATA_ATTR, email);
    } else {
        body.removeAttribute(DATA_ATTR);
    }
}

/**
 * Sets the current user's email in the DOM so the Zoho Chrome extension can read it.
 * Writes to document.body (always present). Uses useMe() for email.
 */
export function ElitphoneUserEmailMeta() {
    const { data: user } = useMe();
    const raw =
        user && typeof user === "object"
            ? ((user as { email?: string; Email?: string }).email ?? (user as { email?: string; Email?: string }).Email)
            : undefined;
    const email = typeof raw === "string" ? raw.trim() : null;

    useLayoutEffect(() => {
        setEmailInDom(email);
        return () => setEmailInDom(null);
    }, [email]);

    return null;
}
